var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26,6.3v6.2c0,0.3-0.3,0.4-0.5,0.2l-2-2l-3.2,3.2c-0.1,0.1-0.3,0.1-0.4,0l-1.8-1.8c-0.1-0.1-0.1-0.3,0-0.4 l3.2-3.2l-2-2C19.1,6.3,19.2,6,19.5,6h6.2C25.9,6,26,6.1,26,6.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6,25.7v-6.2c0-0.3,0.3-0.4,0.5-0.2l2,2l3.2-3.2c0.1-0.1,0.3-0.1,0.4,0l1.8,1.8c0.1,0.1,0.1,0.3,0,0.4l-3.2,3.2 l2,2c0.2,0.2,0.1,0.5-0.2,0.5H6.3C6.1,26,6,25.9,6,25.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFull);
export default __webpack_public_path__ + "static/media/full.cb294f7ece61edf0ba040cb2f3f20632.svg";
export { ForwardRef as ReactComponent };